import { Action } from '@ngrx/store';

import { PostFnolInitPayload } from './post-fnol.models';

export enum PostFnolActionTypes {
  InitPostFnolFlow = '[Post FNOL] Init Flow for Post FNOL',
  ResetPostFnolFlow = '[Post FNOL] Reset Flow for Post FNOL',
  NextStep = '[Post FNOL] Continue to Next Step',
  SkipStep = '[Post FNOL] Skip Step'
}

export class InitPostFnolFlow implements Action {
  readonly type = PostFnolActionTypes.InitPostFnolFlow;
  constructor(public payload: PostFnolInitPayload) {}
}

export class ResetPostFnolFlow implements Action {
  readonly type = PostFnolActionTypes.ResetPostFnolFlow;
  constructor() {}
}

export class NextStep implements Action {
  readonly type = PostFnolActionTypes.NextStep;
  constructor() {}
}

export class SkipStep implements Action {
  readonly type = PostFnolActionTypes.SkipStep;
  constructor() {}
}

export type PostFnolAction = InitPostFnolFlow | ResetPostFnolFlow | NextStep | SkipStep;

export const fromPostFnolActions = {
  InitPostFnolFlow,
  ResetPostFnolFlow,
  NextStep,
  SkipStep
};
